export interface Currency {
  code: string
  symbol: string
  name: string
}

export const currencies: Currency[] = [
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira' },
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'SAR', symbol: 'ر.س', name: 'Saudi Riyal' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'QAR', symbol: 'ر.ق', name: 'Qatari Riyal' },
  { code: 'SYP', symbol: 'ل.س', name: 'Syrian Pound' },
  // Cryptocurrencies
  { code: 'BTC', symbol: '₿', name: 'Bitcoin' },
  { code: 'ETH', symbol: 'Ξ', name: 'Ethereum' },
  { code: 'USDT', symbol: '₮', name: 'Tether' },
  { code: 'BNB', symbol: 'BNB', name: 'Binance Coin' },
  { code: 'SOL', symbol: 'SOL', name: 'Solana' },
  { code: 'XRP', symbol: 'XRP', name: 'Ripple' },
  { code: 'ADA', symbol: '₳', name: 'Cardano' },
  { code: 'DOGE', symbol: 'Ð', name: 'Dogecoin' },
  // Precious Metals
  { code: 'XAU', symbol: 'Au', name: 'Gold' },
  { code: 'XAG', symbol: 'Ag', name: 'Silver' },
  { code: 'XPT', symbol: 'Pt', name: 'Platinum' },
  { code: 'XPD', symbol: 'Pd', name: 'Palladium' },
]

// List of all supported currencies in the app
export const ALL_SUPPORTED_CURRENCIES = [
  'USD', 'EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'CHF', 'CNY', 'HKD', 'NZD', 
  'SEK', 'KRW', 'SGD', 'NOK', 'MXN', 'INR', 'RUB', 'ZAR', 'BRL', 'TRY',
  'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AWG', 'AZN', 'BAM',
  'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BSD', 'BTN',
  'BWP', 'BYN', 'BZD', 'CDF', 'CLP', 'COP', 'CRC', 'CUP', 'CVE', 'CZK',
  'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'FJD', 'GEL', 'GHS',
  'GMD', 'GNF', 'GTQ', 'GYD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS',
  'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'KES', 'KGS', 'KHR', 'KMF', 'KWD',
  'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL',
  'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MYR',
  'NAD', 'NGN', 'NIO', 'NPR', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR',
  'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG',
  'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB',
  'TJS', 'TMT', 'TND', 'TOP', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'UYU',
  'UZS', 'VES', 'VND', 'VUV', 'WST', 'XAF', 'XCD', 'XOF', 'XPF', 'YER',
  'ZMW', 'ZWL',
  // Cryptocurrencies
  'BTC', 'ETH', 'USDT', 'BNB', 'SOL', 'XRP', 'ADA', 'DOGE', 'DOT', 'MATIC',
  'AVAX', 'LINK', 'UNI', 'LTC', 'ATOM', 'XLM', 'NEAR', 'FTT', 'ALGO', 'XMR',
  // Precious Metals
  'XAU', 'XAG', 'XPT', 'XPD', 'XRH'
];

// Default currency used when user hasn't set a preference
export const DEFAULT_CURRENCY = 'USD';

// Currency display options
export const CURRENCY_DISPLAY_OPTIONS = {
  style: 'currency',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};

// Currency symbols for common currencies
export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: 'A$',
  CAD: 'C$',
  CHF: 'Fr',
  CNY: '¥',
  HKD: 'HK$',
  NZD: 'NZ$',
  SEK: 'kr',
  KRW: '₩',
  SGD: 'S$',
  NOK: 'kr',
  MXN: 'Mex$',
  INR: '₹',
  RUB: '₽',
  ZAR: 'R',
  BRL: 'R$',
  TRY: '₺',
  // Cryptocurrencies
  BTC: '₿',
  ETH: 'Ξ',
  USDT: '₮',
  BNB: 'BNB',
  SOL: 'SOL',
  XRP: 'XRP',
  ADA: '₳',
  DOGE: 'Ð',
  DOT: 'DOT',
  MATIC: 'MATIC',
  AVAX: 'AVAX',
  LINK: 'LINK',
  UNI: 'UNI',
  LTC: 'Ł',
  ATOM: 'ATOM',
  XLM: 'XLM',
  NEAR: 'NEAR',
  FTT: 'FTT',
  ALGO: 'ALGO',
  XMR: 'ɱ',
  // Precious Metals
  XAU: 'Au',
  XAG: 'Ag',
  XPT: 'Pt',
  XPD: 'Pd',
  XRH: 'Rh'
};
